/*
 * Mobile menu drawer (snippets/header-drawer.liquid): close the drawer shortly
 * after a link is tapped, so it isn't left open while the next page loads.
 */
document.querySelectorAll('.menu-drawer__menu-item, .menu-drawer__cta-button').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var self = this;
    var href = self.getAttribute('href');

    self.blur();

    // Close drawer after a short delay to allow navigation
    setTimeout(function() {
      var drawer = document.getElementById('Details-menu-drawer-container');
      if (drawer && drawer.hasAttribute('open')) {
        var summary = drawer.querySelector('summary');
        if (summary) {
          summary.click();
        }
      }
    }, 100);
  });
});
